module.exports = __webpack_public_path__ + "img/组 362.30ea8d30.png";